class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.siteHeader = document.getElementById('site-header');
    this.mainContent = document.getElementById('MainContent');
    this.transparentHeaderEnabled = Boolean(
      this.siteHeader?.classList.contains('site-header-transparent')
      || this.siteHeader?.querySelector('.header__heading-logo-wrapper--transparent_alt')
    );
    this.openAnimation = null;
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.closeTimeout = null;

    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onToggle() {
    if (this.mainDetailsToggle.open) {
      this.animateOpen();
    } else if (this.openAnimation) {
      this.openAnimation.cancel();
    }

    this.syncTransparentHeaderState();

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  syncTransparentHeaderState() {
    if (!this.transparentHeaderEnabled || !this.siteHeader || !this.mainContent) return;

    const hasOpenMenu = document.querySelector('header-menu details[open]');
    const shouldRestoreTransparentHeader = !hasOpenMenu && window.pageYOffset < getTransparentHeaderThreshold();

    this.siteHeader.classList.toggle('site-header-transparent', shouldRestoreTransparentHeader);
    this.mainContent.classList.toggle('site-header-transition', !shouldRestoreTransparentHeader);
  }

  isDesktopView() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  onMouseEnter() {
    if (!this.isDesktopView()) return;

    window.clearTimeout(this.closeTimeout);
    this.open();
  }

  onMouseLeave() {
    if (!this.isDesktopView()) return;

    this.closeTimeout = window.setTimeout(() => {
      this.close();
    }, 100);
  }

  onSummaryClick(event) {
    if (!this.isDesktopView()) return;

    event.preventDefault();
    this.open();
  }

  open() {
    window.clearTimeout(this.closeTimeout);
    this.closeOtherMenus();

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  close() {
    window.clearTimeout(this.closeTimeout);
    super.close();
  }

  closeOtherMenus() {
    const openMenus = document.querySelectorAll('header-menu details[open]');

    openMenus.forEach((menu) => {
      if (menu !== this.mainDetailsToggle) {
        menu.removeAttribute('open');
        menu.querySelector('summary').setAttribute('aria-expanded', false);
      }
    });
  }

  animateOpen() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!this.content) return;

    if (this.openAnimation) {
      this.openAnimation.cancel();
    }

    this.content.style.willChange = 'opacity, transform';
    this.openAnimation = this.content.animate(
      [
        { opacity: 0, transform: 'translateY(-1.5rem)' },
        { opacity: 1, transform: 'translateY(0)' },
      ],
      {
        duration: 250,
        easing: 'ease',
      }
    );

    this.openAnimation.addEventListener('finish', () => {
      this.content.style.willChange = '';
    });

    this.openAnimation.addEventListener('cancel', () => {
      this.content.style.willChange = '';
    });
  }
}

customElements.define('header-menu', HeaderMenu);
